export default {"banner":"r1DiE"};